import { el } from 'redom';

class DateInput {

  constructor(configuration) {

    this.onChange = configuration.onChange;

    const inputAttributes = {
      type: 'date',
      disabled: configuration.disabled,
      placeholder: configuration.placeholder,
      onchange: this.handleChange.bind(this),
      onclick: this.handleClick.bind(this)
    };

    if (configuration.min) {
      inputAttributes.min = configuration.min;
    }

    if (configuration.max) {
      inputAttributes.max = configuration.max;
    }

    this.input = el('input.date-input', inputAttributes);

    this.input.value = configuration.value || new Date().toISOString().split('T')[0];

    this.el = el('.date-input-main', [
      this.input
    ]);

  }

  handleClick(event) {

    event.stopPropagation();
    event.target.showPicker();

  }

  handleChange(event) {

    const value = event.target.value;

    this.onChange(event, value);

  }

  setValue(value) {

    this.el.querySelector('input').value = value;

  }

  getValue() {

    return this.el.querySelector('input').value;

  }

  getValueAsDate() {

    return this.el.querySelector('input').valueAsDate;

  }

  getValueAsNumber() {

    return this.el.querySelector('input').valueAsNumber;

  }

  focus() {

    this.el.querySelector('input').focus();

  }

}

export default DateInput;